<template>
  <div class="footer-container">
    <div v-if="dataInfo.backgroundImagePath" class="footer-img-bg">
      <el-image class="image" fit="cover" :src="dataInfo.backgroundImagePath" />
    </div>
    <div class="content">
      <div class="footer-top">
        <div class="footer-left">
          <div class="title">快捷下载</div>
          <div class="left-tab">
            <div class="tab-item" @click="onDownClick(0)">
              <div class="tab-image">
                <img class="image" src="@/assets/icon_footer_win.png" />
              </div>
              <div class="name">Windows ></div>
            </div>
            <div class="tab-item" @click="onDownClick(1)">
              <div class="tab-image">
                <img class="image-ios" src="@/assets/icon_footer_ios.png" />
              </div>
              <div class="name">ios ></div>
            </div>
            <div class="tab-item" @click="onDownClick(2)">
              <div class="tab-image">
                <img
                  class="image-android"
                  src="@/assets/icon_footer_android.png"
                />
              </div>
              <div class="name">Android ></div>
            </div>
          </div>
        </div>
        <div class="footer-right">
          <div class="title">官方客服</div>
          <div class="left-tab">
            <el-popover
              placement="top"
              trigger="hover"
              v-model="weichatService"
            >
              <div>
                <img
                  style="width: 160px; height: 160px"
                  :src="dataInfo.weixinQrcodePath"
                />
              </div>
              <div slot="reference" class="tab-item">
                <div class="tab-image">
                  <img
                    v-if="weichatService"
                    class="image"
                    src="@/assets/icon_weichat_select.png"
                  />
                  <img v-else class="image" src="@/assets/icon_weichat.png" />
                </div>
                <div :class="weichatService ? 'name-select' : 'name'">
                  微信客服
                </div>
              </div>
            </el-popover>
            <el-popover
              placement="top"
              trigger="hover"
              v-model="weichatAccount"
            >
              <div>
                <img
                  style="width: 160px; height: 160px"
                  :src="dataInfo.weixinPublicQrcodePath"
                />
              </div>
              <div slot="reference" class="tab-item">
                <div class="tab-image">
                  <img
                    v-if="weichatAccount"
                    class="image"
                    src="@/assets/icon_weichat_select.png"
                  />
                  <img v-else class="image" src="@/assets/icon_weichat.png" />
                </div>
                <div :class="weichatAccount ? 'name-select' : 'name'">
                  微信公众号
                </div>
              </div>
            </el-popover>
            <el-popover placement="top" trigger="hover" v-model="qqService">
              <div>
                <img
                  style="width: 160px; height: 160px"
                  :src="dataInfo.qqQrcodePath"
                />
              </div>
              <div slot="reference" class="tab-item">
                <div class="tab-image">
                  <img
                    v-if="qqService"
                    class="image"
                    src="@/assets/icon_qq_select.png"
                  />
                  <img v-else class="image" src="@/assets/icon_qq.png" />
                </div>
                <div :class="qqService ? 'name-select' : 'name'">QQ客服</div>
              </div>
            </el-popover>
          </div>
        </div>
      </div>
      <div class="footer-bottom">
        {{ dataInfo.copyright }}︱{{ dataInfo.companyName }}︱<a
          target="blank"
          href="https://beian.miit.gov.cn/"
          class="beianhao"
          >{{ dataInfo.archivalInfo }}</a
        >
        <div class="footer-contact">
          联系电话：+86 17881880002&nbsp;&nbsp;&nbsp;&nbsp;联系地址：深圳市南山区粤海街道科技园社区科苑路15号科兴科学园C栋C3-13F-B128
        </div>
        <div class="footer-police">
          <img src="@/assets/icon_police.png" style="width: 20px; vertical-align: middle;" />
          <a href="https://beian.mps.gov.cn/#/query/webSearch?code=44030002013341" rel="noreferrer" target="_blank">粤公网安备44030002013341号</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getPageFooter } from "@/api/home";
import { EventBus } from "@/utils/eventbus.js";
export default {
  name: "Footer",
  data() {
    return {
      active: 0,
      weichatAccount: false,
      weichatService: false,
      qqService: false,
      dataInfo: {},
    };
  },
  created() {
    this._getPageFooter();
  },
  methods: {
    onBeiAnHaoClick() {},
    onDownClick(position) {
      const { path } = this.$route;
      if (path === "/downmanage") {
        EventBus.$emit("onDownClick", position);
        return;
      }
      this.$router.replace({
        path: "/downmanage",
        query: { position },
      });
    },
    _getPageFooter() {
      getPageFooter()
        .then((res) => {
          const { data } = res;
          this.dataInfo = { ...data };
        })
        .catch((res) => {})
        .finally(() => {});
    },
  },
};
</script>

<style lang="scss" scoped>
.footer-container {
  background-color: #333333;
  padding-left: 20px;
  min-height: 300px;
  padding-right: 20px;
  padding-bottom: 30px;
  position: relative;
  .footer-img-bg {
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 0;
    right: 0;
    .image {
      width: 100%;
      height: 100%;
    }
  }
  .content {
    position: relative;
    width: 1320px;
    margin: 0 auto;
    padding-top: 35px;
    z-index: 1;
    .footer-top {
      display: flex;
      justify-content: space-between;
      .footer-left {
        .title {
          text-align: left;
          font-size: 20px;
          color: #999999;
          padding-bottom: 30px;
        }
        .left-tab {
          display: flex;
          align-items: baseline;
          .tab-item {
            text-align: center;
            margin-right: 55px;
            cursor: pointer;
            .tab-image {
              .image {
                width: 50px;
                height: 50px;
              }
              .image-ios {
                width: 49px;
                height: 60px;
              }
              .image-android {
                width: 51px;
                height: 60px;
              }
            }
            .name {
              padding-top: 17px;
              font-size: 20px;
              color: #999999;
            }
          }
        }
      }
      .footer-right {
        .title {
          font-size: 20px;
          color: #999999;
          padding-bottom: 30px;
          text-align: left;
          padding-left: 50px;
        }

        .left-tab {
          display: flex;
          align-items: baseline;
          .tab-item {
            margin-left: 50px;
            cursor: pointer;

            .tab-image {
              .image {
                width: 60px;
                height: 60px;
              }
            }
            .name,
            .name-select {
              padding-top: 12px;
              font-size: 20px;
              color: #999999;
            }
            .name-select {
              color: #ffffff;
            }
          }
        }
      }
    }
    .footer-bottom {
      width: 100%;
      padding-top: 50px;
      text-align: center;
      font-size: 16px;
      color: #999999;
      line-height: 2;
      .beianhao {
        color: #999999;
        text-decoration: none;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue